var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", viewBox: "0 0 20 20", className: styles["cross-img-icon"] || "cross-img-icon" }, props),
    React.createElement("rect", { width: "19", height: "19", x: ".5", y: ".5", fill: "#18AF8B", stroke: "#F4FBF9", rx: "9.5" }),
    React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M14.66 6.17c.32.23.32.61.08.85L8.31 13c-.08.12-.23.18-.47.18a.8.8 0 0 1-.47-.21l-2.74-3c-.24-.25-.16-.63.08-.84.31-.22.7-.19.94.07l2.27 2.49 5.88-5.52a.62.62 0 0 1 .86-.01z", clipRule: "evenodd" })
  );
});